jQuery( document ).ready(function($) {
    $(".custom-accordion .accordion_head").click(function () {
    const $wrapper = $(this).closest(".accordion-wrapper");
    // Close all
    $(".accordion_body").slideUp(300);
    $(".accordion-wrapper").removeClass("active");
    // Open clicked one if not already visible
    if (!$(this).next(".accordion_body").is(":visible")) {
        $(this).next(".accordion_body").slideDown(300);
        $wrapper.addClass("active");
    }
    });
});

jQuery(document).ready(function ($) {
  function updateCartCount() {
    $.getJSON('/cart.js', function (cart) {
      $('#CartCount').text(cart.item_count);
    });
  }

  // Run once on page load
  updateCartCount();

  // Keep running every 3 seconds (you can adjust the interval)
  setInterval(updateCartCount, 3000);
});


jQuery(document).ready(function($) {
    var owl = $("section.testimonial-section .owl-carousel");
    owl.owlCarousel({
    items: 3,
    margin: 20,
    loop: true,
    nav: false,
    responsive: {
        0: {
        items: 1
        },
        768: {
        items: 2
        },
        1200: {
        items: 3
        }
    },
    autoplay: true,
    autoplayTimeout: 3000,
    autoplayHoverPause: true,
    smartSpeed: 1000,
    dots: false
    });	
});

jQuery(document).ready(function($) {
  // When any accordion opens
  $(document).on('click', 'details', function() {
    // Close all other accordions
    $('details').not(this).removeAttr('open');
  });
});

jQuery(document).ready(function ($) {
  $('#CartToggle').on('click', function (e) {
    e.preventDefault();
    $('.slidecarthq-overlay, .slidecarthq').addClass('open');
  });
  $(document).on('click', 'button[aria-label="close cart"], .slidecarthq-overlay', function () {
    $('.slidecarthq-overlay, .slidecarthq').removeClass('open');
  });
});


// jQuery(document).ready(function ($) {
//   $('.add-to-cart-btn').on('click', function (e) {
//     e.preventDefault();
//     var variantId = 47073219608750;
//     $.ajax({
//       type: 'POST',
//       url: '/cart/add.js',
//       data: { id: variantId, quantity: 1 },
//       dataType: 'json',
//       success: function (response) {
//         console.log('Added to cart:', response);
//         window.location.href = window.location.pathname + '?opencart=true';
//       },
//       error: function (xhr, status, error) {
//         console.error('Error adding to cart:', error);
//       }
//     });
//   });

//   const urlParams = new URLSearchParams(window.location.search);
//   if (urlParams.has('opencart')) {
//     $(window).on('load', function () {
//         document.getElementById('CartToggle').click();
//         const cleanUrl = window.location.origin + window.location.pathname;
//         window.history.replaceState({}, document.title, cleanUrl);
//     });
//   }
// });





setTimeout(function () {
AOS.init();
}, 1000); 
